.container {
	margin-left: 5px;
}

.moreIconWrapper {
	display: flex;
	align-items: center;
	padding: 2px 3px;
	width: calc(var(--jpo-icon-size-small) + 8px);
	margin: 0;
}
